import { useLocation, useParams } from 'react-router-dom';

export const useBasePath = () => {
	const location = useLocation();
	const params = useParams<Record<string, string>>();

	return Object.keys(params).reduce(
		(path, param) => path?.replace(`${params[param]}`, `:${param}`),
		location.pathname,
	);
};
